import React, { useRef } from 'react'
import {
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  useAsyncSelect
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { searchCriteriaState } from '../recoil/states/searchCriteria'
import { errorCallback } from '../recoil/callbacks/callbacks'
import { getGroupById, getGroups } from '../recoil/actions/asyncSearch'

import { INPUT_GROUPS_MAX_ITEMS } from 'Constants/index'
import debounce from 'lodash.debounce'

const ExcludeGroups = () => {
  const intl = useIntl()

  const [{ excludeGroups }, setSearchCriteria] = useRecoilState(
    searchCriteriaState
  )

  const onError = useRecoilCallback(errorCallback, [])

  const getInitialItems = () => getGroups()

  const getItemsByTerm = searchTerm => getGroups(searchTerm)

  const hints = {
    loading: intl.formatMessage({ id: 'Load.MailupCommon.InputStatusLoading' }),
    moreResults: intl.formatMessage({
      id: 'Load.Filters.ActivityMessagesMoreResults'
    }),
    noResults: intl.formatMessage({ id: 'Load.Common.NoResultChosen' })
  }

  const {
    options,
    loading,
    hint,
    hintNoResults,
    onSearch,
    onChange,
    onExpandCollapse
  } = useAsyncSelect({
    initialValue: excludeGroups,
    getInitialItems,
    getItemsByTerm,
    getItemById: getGroupById,
    onError,
    hints,
    maxItems: INPUT_GROUPS_MAX_ITEMS
  })

  const handleChange = value => {
    setSearchCriteria(({ includeGroups, ...prev }) => ({
      ...prev,
      excludeGroups: value,
      includeGroups: includeGroups.filter(e => !value.includes(e)),
      isNewSerach: true
    }))

    onChange(value)
  }

  const { current: debouncedOnSearch } = useRef(debounce(onSearch, 350))

  const handleSearch = s => {
    debouncedOnSearch.cancel()
    debouncedOnSearch(s)
    return s
  }

  return (
    <Select
      multiple
      searchable
      variant={SELECT_VARIANT_WITH_CHECKBOX}
      value={excludeGroups}
      hint={hint}
      hintNoResults={hintNoResults}
      onChange={handleChange}
      loading={loading}
      options={options}
      onSearch={handleSearch}
      onExpandCollapse={onExpandCollapse}
      placeholder={intl.formatMessage({
        id: 'Load.Rcs.RecipientsSelectionGroupsExcludePlaceholder'
      })}
    />
  )
}

export default ExcludeGroups
